import React, { Component } from "react";
import Gallery from "react-grid-gallery";
import "../style/gallery.scss";

// https://lh3.google.com/u/0/d/

class GalleryView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: "",
      isLoading: false,
      data: [],
      breadcrumbs: [{ text: "Home", id: "1MDEH2bQD6WlM38hJOiA7HbHciLaB0jM4" }],
    };
  }
  componentDidMount() {
    this.handleNavigate();
  }

  handleBreadcrumb = (crumb, index) => {
    let breadcrumbs = this.state.breadcrumbs;
    let i = breadcrumbs.length;
    while (i > index + 1) {
      breadcrumbs.pop();
      i--;
    }
    this.setState({
      ...this.state,
      breadcrumbs,
    });
    this.handleNavigate(crumb.id);
  };

  addBreadcrumb = (id, title) => {
    let breadcrumbs = this.state.breadcrumbs;
    breadcrumbs.push({ id, text: title });
    this.setState({
      ...this.state,
      breadcrumbs,
    });
    this.handleNavigate(id);
  };

  handleNavigate = (id = "1MDEH2bQD6WlM38hJOiA7HbHciLaB0jM4") => {
    this.setState({
      ...this.state,
      isLoading: true,
    });
    fetch(
      `https://www.googleapis.com/drive/v2/files?q='${id}'+in+parents&key=${process.env.REACT_APP_API_KEY}`
    )
      .then((res) => res.json())
      .then((res) => {
        let folders = res.items.filter((item) => {
          return item.mimeType === "application/vnd.google-apps.folder";
        });
        let images = res.items
          .filter((item) => {
            return item.mimeType === "image/jpeg";
          })
          .map((image) => {
            return {
              thumbnail: `${image.thumbnailLink}`,
              thumbnailWidth: image.imageMediaMetadata.width,
              thumbnailHeight: image.imageMediaMetadata.height,
              caption: image.title,
              src: `https://lh3.google.com/u/0/d/${image.id}`,
            };
          });
        this.setState({
          ...this.state,
          images,
          folders,
          isLoading: false,
        });
      });
  };

  render() {
    let folders = this.state.folders;
    let images = this.state.images;
    let breadcrumbs = this.state.breadcrumbs;
    let isLoading = this.state.isLoading;
    return (
      <div className="gallery">
        <div className="container">
          <div className="row">
            {breadcrumbs &&
              breadcrumbs.map((crumb, index) => {
                return (
                  <button
                    className="breadcrumb"
                    key={crumb.id}
                    onClick={() => this.handleBreadcrumb(crumb, index)}
                  >
                    {crumb.text}
                  </button>
                );
              })}
          </div>
          {isLoading && isLoading === true ? (
            <div className="progress">
              <div className="indeterminate" />
            </div>
          ) : (
            ""
          )}

          <div className="row">
            <h3>Folders</h3>
            <table className="responsive-table">
              <tbody>
                {folders && folders.length > 0 ? (
                  folders.map((folder) => {
                    return (
                      <tr
                        key={folder.id}
                        onClick={() =>
                          this.addBreadcrumb(folder.id, folder.title)
                        }
                      >
                        <td>
                          <img
                            src={folder.iconLink}
                            alt="An icon of a folder"
                          />
                        </td>
                        <td>{folder.title}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="h4">No folders</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="row">
            <h3>Images</h3>
            {images && images.length > 0 ? (
              <Gallery
                images={images}
                enableImageSelection={false}
                backdropClosesModal={true}
                preloadNextImage={true}
              />
            ) : (
              <p>No images</p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GalleryView;
